import axios from "axios";
import Vue from "vue";
import router from "@/router";
import qs from "qs";
import merge from "lodash/merge";
import _ from "lodash";
import { hideLoading, showLoading } from "@/utils/loading";
import { clearLoginInfo } from "@/utils";

const http = axios.create({
  timeout: 2000 * 10,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8"
  }
});

/**
 * 请求拦截
 */
http.interceptors.request.use(
  config => {
    let $u = Vue.prototype.$u;
    // 请求头带上token
    config.headers[$u.constant.AUTH_TOKEN_HEADER] =
      $u.store.state.user.vuex_token;
    if (config.showLoading) {
      showLoading();
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截
 */
http.interceptors.response.use(
  response => {
    hideLoading();
    if (!response.data) {
      return Promise.reject(response);
    }
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.data.code === Vue.prototype.$u.dict.WebStatus.SUCCESS) {
      return response;
    }
    if (response.config.showMsg) {
      //直接错误提示
      Vue.prototype.$u.message.error(response.data.message);
    }
    if (response.data.code === Vue.prototype.$u.dict.WebStatus.UNAUTHORIZED) {
      clearLoginInfo();
      router.push({ name: Vue.prototype.$u.routerConst.LOGIN });
    }
    return Promise.reject(response);
  },
  error => {
    hideLoading();
    if (!error.response) {
      Vue.prototype.$u.message.error("网络异常！");
      return;
    }
    if (error.response.status) {
      switch (error.response.status) {
        // 404请求不存在
        case 404:
          Vue.prototype.$u.message.error("网络请求不存在！");
          break;
        case 500:
          Vue.prototype.$u.message.error("服务器异常！");
        // 其他错误，直接抛出错误提示
        // eslint-disable-next-line no-fallthrough
        default:
      }
      return Promise.reject(error.response);
    }
  }
);

//额外的附加配置
let extraReqConfig = { dataType: "json", showLoading: true, showMsg: true };
/**
 * get请求封装
 * @author miaoguoxin
 * @date 2020/10/4
 */
export function get(url, params, config = extraReqConfig) {
  let shallow = _.clone(extraReqConfig);
  let c = merge(shallow, config);
  let data = {
    params: params
  };
  return new Promise((resolve, reject) => {
    http
      .get(url, merge(data, c))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 * @param config
 */
export function post(url, params, config = extraReqConfig) {
  let shallow = _.clone(extraReqConfig);
  let c = merge(shallow, config);
  return new Promise((resolve, reject) => {
    http
      .post(url, convertParams(params, c.dataType), c)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param config
 */
export function del(url, params, config = extraReqConfig) {
  let shallow = _.clone(extraReqConfig);
  let c = merge(shallow, config);
  let data = {
    params: params
  };
  return new Promise((resolve, reject) => {
    http
      .delete(url, merge(data, c))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param config 附加的配置信息
 */
export function put(url, params, config = extraReqConfig) {
  let shallow = _.clone(extraReqConfig);
  let c = merge(shallow, config);
  return new Promise((resolve, reject) => {
    http
      .put(url, convertParams(params, config.dataType), c)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

//自定义请求
export function req(reqConfig) {
  let shallow = _.clone(extraReqConfig);
  let c = merge(shallow, reqConfig);
  return new Promise((resolve, reject) => {
    http(c)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

function convertParams(params, contentType) {
  return contentType === "json" ? JSON.stringify(params) : qs.stringify(params);
}
